<template>
  <div>
    <div class="mb-3" v-if="state.PostKeyTags && state.PostKeyTags.length > 0">
      <K2Text bold="true">{{ lang('Tags') }}:</K2Text>
      <K2Row class="flex-wrap">
        <K2Row justify_content="center" align="center" v-for="tag in state.PostKeyTags" :key="tag.KeyTag" class="box purple me-2 mt-2 rounded-pill px-2 py-1">
          <K2Text :color="uiVariable.color.purple">{{ tag.KeyTag }}</K2Text>
        </K2Row>
      </K2Row>
    </div>

    <K2Row>
      <div class="me-2">
        <K2Text bold="true" v-if="state.PostIsUpdated">{{ lang('Modified on') }}:</K2Text>
        <K2Text bold="true" v-else>{{ lang('Created On') }}:</K2Text>
        <K2Text :color="uiVariable.color.purple">
          {{ getCreatedDate() }}
        </K2Text>
      </div>
      <div class="me-2">
        <K2Text bold="true">{{ lang('Post Type') }}:</K2Text>
        <K2Text :color="uiVariable.color.purple" v-if="isBroadcastPost"> Broadcast</K2Text>
        <K2Text :color="uiVariable.color.purple" v-else> {{ isNewsfeed ? lang('Feeds') : lang(postType) }}</K2Text>
      </div>
      <div>
        <K2Text bold="true">{{ lang('Teacher') }}:</K2Text>
        <K2Text :color="uiVariable.color.purple"> {{ getUserName() }}</K2Text>
      </div>
    </K2Row>
  </div>
</template>

<script>
import uiVariable from '@/config/uiVariable'
import K2Text from '@/uiComponents/k2Text/k2Text'
import K2Row from '@/uiComponents/k2Row/k2Row'
import { lang } from '../../../../../locale'
import { getFormatDate } from '@/helper/utily'
import { getUserNameSession } from '@/helper/util_custom'

export default {
  name: 'NewPostPreviewFooter',
  components: { K2Row, K2Text },
  props: ['state', 'postType', 'isBroadcastPost', 'isNewsfeed'],
  data() {
    return {
      uiVariable: uiVariable,
    }
  },
  methods: {
    lang,
    getCreatedDate() {
      return getFormatDate(new Date(), 'DD/MM/YYYY [ ] HH:mm')
    },
    getUserName() {
      return getUserNameSession()
    },
  },
}
</script>
